import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);
const config = {
  plugins: [createPersistedState()],
  state: {
    loginInfo: JSON.parse(window.localStorage.getItem("loginInfo")) || null,
    userInfo: JSON.parse(window.localStorage.getItem("userInfo")) || null,
    curPage: null,
    settingData: null,
    // language: window.localStorage.getItem("language") || "zh",
  },
  getters: {
    loginInfo: (state) => state.loginInfo,
    userInfo: (state) => state.userInfo,
    curPage: (state) => state.curPage,
    settingData: (state) => state.settingData,
    // language: (state) => state.language,
  },
  mutations: {
    updateSettingData(state, payload) {
      payload.payment_instructions.content = payload.payment_instructions
        .content
        ? payload.payment_instructions.content.replace(/\n/g, "<br>")
        : "";
      state.settingData = payload;
    },
    updateLoginInfo(state, payload) {
      state.loginInfo = payload;
      window.localStorage.setItem("loginInfo ", JSON.stringify(payload));
    },
    updateUserInfo(state, payload) {
      state.userInfo = payload;
      window.localStorage.setItem("userInfo ", JSON.stringify(payload));
    },
    moreInfo(state, payload) {
      state.loginInfo = null;
      state.userInfo = null;
      window.localStorage.removeItem("loginInfo");
      window.localStorage.removeItem("userInfo");
      window.localStorage.removeItem("vuex");
    },
    setCurPageM(state, payload) {
      state.curPage = payload;
    },

    LOG_OUT_MOREINFO(state, payload) {
      state.loginInfo = null;
      state.userInfo = null;
      window.localStorage.removeItem("loginInfo");
      window.localStorage.removeItem("userInfo");
      window.localStorage.removeItem("vuex");
      console.log(123423)
    },
    // setLanguageM(state, payload) {
    //   state.language = payload;
    //   window.localStorage.setItem("language ", payload);
    // },
  },
  actions: {
    // setLanguage({ commit, state }, language) {
    //   commit("setLanguageM", language);
    // },
    setCurPage({ commit, state }, curPage) {
      commit("setCurPageM", curPage);
    },
    actionsMoreInfo({ commit, state }, code) {
      return new Promise((resolve, reject) => {
        commit("moreInfo");
        resolve();
      });
    },
    logOut({ commit, state }, code) {
      return new Promise((resolve, reject) => {
        commit("LOG_OUT_MOREINFO");
        resolve();
      });
    },
    getSetting({ commit, state }, code) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$axios
          .post(`/setting/setting`, code)
          .then((res) => {
            if (res.code == 200) {
              commit("updateSettingData", res.data);
              resolve(res);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    login({ commit, state }, code) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$axios
          .post(`/login`, code)
          .then((res) => {
            if (res.code == 200) {
              commit("updateLoginInfo", res.data);
              this.dispatch("getInfo")
                .then((res) => {})
                .catch((error) => {});
              resolve(res);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // get user info
    getInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$axios
          .post(`/me`)
          .then((res) => {
            if (res.code == 200) {
              commit("updateUserInfo", res.data.item);
              resolve(res.data);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
const store = new Vuex.Store(config);
export default store;
